import { jsx as _jsx } from "react/jsx-runtime";
import doubleTerminatedUrl from '../../../assets/gems/double_terminated.svg?inline';
export function DoubleTerminated({ ...props }) {
    return _jsx("img", { ...props, src: doubleTerminatedUrl, alt: 'DoubleTerminatedImage' });
}
